/* Counts Shopify-accepted enquiries, not submit-button clicks. No field values are collected. */
(() => {
  'use strict';
  if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main' ||
      new URLSearchParams(location.search).has('preview_theme_id')) return;
  const ttl = 30 * 60 * 1000;
  const prefix = 'co2-enquiry:';
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const emit = (name, props) => { try { window.plausible?.(name, { props }); } catch (_) {} };
  document.querySelectorAll('[data-co2-enquiry]').forEach(marker => {
    const form = marker.closest('form');
    if (!form) return;
    const kind = marker.dataset.co2Enquiry;
    const key = prefix + location.pathname + ':' + form.id + ':' + kind;
    const pending = read(key);
    if (marker.dataset.co2Status === 'success' && pending?.submitted &&
        Date.now() - pending.submitted >= 0 && Date.now() - pending.submitted < ttl) {
      remove(key); // Consume before sending: refresh/back must not count another enquiry.
      emit('Enquiry Submitted', { enquiry_type: kind });
    } else if (pending?.submitted && (marker.dataset.co2Status === 'error' || Date.now() - pending.submitted >= ttl)) {
      remove(key);
    }
    let started = false;
    const start = event => {
      if (started || !event.isTrusted) return;
      started = true;
      emit('Enquiry Started', { enquiry_type: kind });
    };
    form.addEventListener('input', start);
    form.addEventListener('change', start);
    form.addEventListener('submit', event => {
      // Native validation precedes submit. Do not interfere with CAPTCHA or Shopify submission.
      if (!event.isTrusted || event.defaultPrevented) return;
      write(key, { submitted: Date.now() });
    });
  });
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (/^mailto:/i.test(href)) emit('Email Click', {});
    else if (/^tel:/i.test(href)) emit('Phone Click', {});
    else if (/\/CO2balance_Biochar_Feasibility_Questionnaire_Download\.docx(?:\?|$)/i.test(href)) {
      emit('Questionnaire Download', { questionnaire: 'Biochar feasibility' });
    }
  });
})();
